import { ReactNode, lazy, Suspense } from "react";
import { Header } from "./Header";

const Footer = lazy(() => import("./Footer").then(m => ({ default: m.Footer })));
const CookieConsentBanner = lazy(() => import("@/components/cookies/CookieConsent").then(m => ({ default: m.CookieConsentBanner })));

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        {children}
      </main>
      <Suspense fallback={null}>
        <Footer />
        <CookieConsentBanner />
      </Suspense>
    </div>
  );
}
